/**
 * @module utils/index
 */
/** 
 * 工具类
 * @fileoverview 工具类
 
 * @author Rfan
 */
 
import store from '@/store';

/**
 * @description: 检测APP名称
 * @return {string} app name
 */
 export function checkoutApp() {
  let name = '';
  const baseQuery = store.getters.getQuery;
  const url = window.location.href;
  if (baseQuery.channel.toLowerCase().indexOf('panda') >= 0 || url.indexOf('//static.pandapaint.net') >= 0) {
    name = 'panda';
  } else if (baseQuery.channel.toLowerCase().indexOf('pro') >= 0) {
    name = 'hsjpro';
  } else {
    name = 'hsj';
  }
  return name;
}

/**
 * @description: 检测APP名称
 * @param {string} name
 * @return {string} app name
 */
export function testApp(name) {
  return checkoutApp() === name;
}

export function platform() {
  let system = '';
  let ua = navigator.userAgent
  let p = navigator.platform
  let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  let isMac = !!ua.match(/\(Macintosh.+Mac OS X/); // mac
  if (isMac) {
    if (p.indexOf("Mac") == 0) {
      system = 'ios'
    } else {
      system = 'ios'
    }
  } else if (isiOS) {
    system = 'ios'
  } else {
    system = 'android'
  }
  return system
}

export function testPlatform(os) {
  return platform() === os
}
